'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _RequestStatusTypes2.default.LOADING;

var PurchaseMotionRequestStatus = function PurchaseMotionRequestStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case _ActionTypes2.default.PURCHASE_MOTION_DATA_REQUESTED:
      return _RequestStatusTypes2.default.LOADING;
    case _ActionTypes2.default.PURCHASE_MOTION_DATA_SUCCEEDED:
      return _RequestStatusTypes2.default.SUCCEEDED;
    case _ActionTypes2.default.PURCHASE_MOTION_DATA_FAILED:
      return _RequestStatusTypes2.default.FAILED;
    default:
      return state;
  }
};

exports.default = PurchaseMotionRequestStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/PurchaseMotionRequestStatus.js
// module id = 397
// module chunks = 3 4 5